import { EntityTypeSupportingPinnedFields } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { isEntityTypeSupportingCustomSourceObject } from "@mapmycustomers/shared/util/assert";

import RecordPreviewConfigurationColumns from "./RecordPreviewConfigurationColumns";

// The subtype's merged list when the record type has one for the record's sourceObject, else the
// shared list. Both come straight from the selector output, so readers can memoise on the result.
export const getRecordColumns = (
  columns: RecordPreviewConfigurationColumns,
  {
    entity,
    sourceObject,
  }: { entity: EntityTypeSupportingPinnedFields; sourceObject?: null | string }
): IField[] =>
  (isEntityTypeSupportingCustomSourceObject(entity) && sourceObject
    ? columns.bySubtype[entity].get(sourceObject)
    : undefined) ?? columns.shared[entity];

export const getSharedColumns = (
  columns: RecordPreviewConfigurationColumns,
  entityType: EntityTypeSupportingPinnedFields
): IField[] => columns.shared[entityType];
